import React from 'react';
import ReactDOM from 'react-dom';

import { AppRoot } from 'components/AppRoot';

ReactDOM.render(React.createElement(AppRoot), document.getElementById('root'));
